export default __webpack_public_path__ + "static/protionBanner-b84c87557aaf0d0dda7a347d336a7afe.png";